import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetchArgs } from 'src/app/shared/models/core';
import { FeatureFlag } from '../../../shared/models/enums/feature-flag';
import { ProfileRequirement } from '../../models/profile-requirements.model';
import { AvaiableStateForRequirement } from '../../models/state-requirement.model';
import { StateRequirementService } from '../../state-requirement/state-requirement.service';
import { AvailableStatesDto } from '../models/available-states-dto.model';
import { ProfileRequirementsDto } from '../models/profile-requirements-dto.model';
import { ProfileRequirementsFilterDto } from '../models/profile-requirements-filter-dto.model';
import { StateRequirementClient } from '../state-requirement-client.service';
import { NSwagMigrationService } from './nswag-migration.service';

// 2 endpoints
@Injectable({ providedIn: 'root' })
export class StateRequirementNSwagMigrationService extends NSwagMigrationService {
    protected readonly className = 'StateRequirementNSwagMigrationService';
    protected readonly featureFlag = FeatureFlag.NSwagMigrationStateRequirementService;
    private readonly legacy = inject(StateRequirementService);
    private readonly stateRequirementClient = inject(StateRequirementClient);

    // ** StateRequirementController.GetAvailableStatesAsync
    public getAvailableStateForRequirements(args: FetchArgs): Observable<AvaiableStateForRequirement[] | AvailableStatesDto[]> {
        const filter: AvailableStatesDto = args.filter ?? {};
        return this.invoke(x => x
            ? this.legacy.getAvailableStateForRequirements(args)
            : this.stateRequirementClient.getAvailableStates(
                filter.stateId, // filter_StateId
                filter.stateName, // filter_StateName
                filter.stateCode, // filter_StateCode
                args.pageSize, // pageSize
                args.skip, // skip
                args.sort?.field, // sort_Field
                args.sort?.dir as any, // sort_Type
                undefined // paginated
            ));
    }

    // ** StateRequirementController.GetStateGlobalRequirements
    public getStateGlobalRequirements(stateId: number, args: FetchArgs): Observable<ProfileRequirement[] | ProfileRequirementsDto[]> {
        const filter: ProfileRequirementsFilterDto = args.filter ?? {};
        return this.invoke(x => x
            ? this.legacy.getStateGlobalRequirements(stateId, args)
            : this.stateRequirementClient.getStateGlobalRequirements(
                stateId,
                filter.requirementId, // filter_RequirementId
                filter.requirementName, // filter_RequirementName
                filter.taskType, // filter_TaskType
                filter.clientPortalVisibility, // filter_ClientPortalVisibility
                filter.requirementLevel, // filter_RequirementLevel
                filter.qualificationSettingsLevel, // filter_QualificationSettingsLevel
                filter.linesOfBusiness, // filter_LinesOfBusiness
                filter.isDefault, // filter_IsDefault
                filter.expirationRequired, // filter_ExpirationRequired
                filter.requirementDescription, // filter_RequirementDescription
                filter.externalRequirementDescription, // filter_ExternalRequirementDescription
                filter.categoryLineOfBusinessId, // filter_CategoryLineOfBusinessId
                filter.acceptanceCriteriaType, // filter_AcceptanceCriteriaType
                filter.acceptanceCriteriaStatus, // filter_AcceptanceCriteriaStatus
                args.pageSize, // pageSize
                args.skip, // skip
                args.sort?.field, // sort_Field
                args.sort?.dir as any, // sort_Type
                undefined // paginated
            ));
    }
}
